import React from 'react';
import { FormMap, Props } from './form.type';
import Contact from './contact/Contact';
import Verification from './verification/Verification';
import Company from './company/Company';

function RecruiterForm({ mode }: Props) {
  const formMap: FormMap = {
    contact: <Contact />,
    company: <Company />,
    verify: <Verification />
  };

  return formMap[mode];
}

export default RecruiterForm;
